import { ArrowRight } from "lucide-react";

export const GoldBanner = () => (
  <a href="/giveaway" data-testid="gold-giveaway-banner"
    className="block" style={{ background: "linear-gradient(90deg, #171007, #3B2A10 50%, #171007)" }}>
    <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center justify-center gap-3 sm:gap-4">
      <img src="/gold-coin.png" alt="Gold and silver coin monthly giveaway" width="44" height="44" className="h-10 w-10 sm:h-11 sm:w-11 object-contain shrink-0" style={{ filter: "drop-shadow(0 0 10px rgba(232,179,58,0.85))" }} loading="lazy" />
      <p className="hidden sm:block text-sm sm:text-base font-bold leading-snug" style={{ color: "#F3D27A" }}>
        Dine In, Win Gold. Order Online, Win Silver. <span className="font-medium" style={{ color: "#D9B55F" }}>Monthly draw of a 1 gram gold coin for dine-in guests, and a 1 oz silver coin for online orders.</span> <span className="underline" style={{ color: "#E8B33A" }}>Rules</span>
      </p>
      <p className="sm:hidden text-sm font-bold leading-snug" style={{ color: "#F3D27A" }}>
        Dine In, Win Gold. Order Online, Win Silver. <span className="font-medium" style={{ color: "#D9B55F" }}>Monthly draws.</span> <span className="underline" style={{ color: "#E8B33A" }}>Rules</span>
      </p>
      <ArrowRight size={15} style={{ color: "#E8B33A" }} className="shrink-0" aria-hidden="true" />
    </div>
  </a>
);

export default GoldBanner;
